<template>
  <div class="popup" v-if="showModal">
    <div class="popup-body special-scroll special-scroll-dark">
      <div class="row">
        <div class="col-12">
          <h3 class="text-right">שם המתמודד/ת</h3>
          <input title="שם המתמודד/ת" v-model="category.name" type="text" placeholder="שם">
        </div>
      </div>
      <div class="popup-images">
        <h3>קטגוריה</h3>
        <div class="popup-image">
          <div class="popup-image-item image-1" id="pick-cat-1"
               :style='{"background-image":"url(\""+category.images.main+"\")"}'></div>
          <avatar-cropper
              @uploaded="handleUploaded1"
              trigger="#pick-cat-1"
              upload-url="https://ivote.tv/api/"
              :upload-form-data="{userId:userId}"
              :output-quality="imgQuality"
              :cropper-options="{autoCropArea: 2, autoCropArea: 1,cropBoxResizable: false}"
              :output-options="{width: 800, height: 400}"
              :labels="{ submit: 'אישור', cancel: 'ביטול'}"
          />
        </div>
        <h3>סילואטה</h3>
        <div class="popup-image">
          <div class="popup-image-item image-1" id="pick-cat-2"
               :style='{"background-image":"url(\""+category.images.sill+"\")"}'></div>
          <avatar-cropper
              @uploaded="handleUploaded2"
              trigger="#pick-cat-2"
              upload-url="https://ivote.tv/api/"
              :upload-form-data="{userId:userId}"
              :output-quality="imgQuality"
              :cropper-options="{autoCropArea: 2, autoCropArea: 1,cropBoxResizable: false}"
              :output-options="{width: 800, height: 400}"
              :labels="{ submit: 'אישור', cancel: 'ביטול'}"
          />
        </div>
        <h3>חשיפה</h3>
        <div class="popup-image">
          <div class="popup-image-item image-1" id="pick-cat-3"
               :style='{"background-image":"url(\""+category.images.show+"\")"}'></div>
          <avatar-cropper
              @uploaded="handleUploaded3"
              trigger="#pick-cat-3"
              upload-url="https://ivote.tv/api/"
              :upload-form-data="{userId:userId}"
              :output-quality="imgQuality"
              :cropper-options="{autoCropArea: 2, autoCropArea: 1,cropBoxResizable: false}"
              :output-options="{width: 800, height: 400}"
              :labels="{ submit: 'אישור', cancel: 'ביטול'}"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <h3 class="text-right">תמונה מוצגת</h3>
          <select v-model="category.img">
            <option value="main">ראשית</option>
            <option value="sill">סילואטה</option>
            <option value="show">חשיפה</option>
          </select>
        </div>
        <div class="col-6">
          <h3 class="text-right">מצב הצבעה</h3>
          <select v-model="category.state">
            <option value="0">צפייה בלבד</option>
            <option value="1">פתוחה</option>
            <!--            <option value="2">חסומה</option>-->
          </select>
        </div>
        <div class="col-12">
          <h3 class="text-right">מועמד מאחורי המסכה</h3>
          <select v-model="category.playerId">
            <option :key="'po-'+k" :value="p.id" v-for="(p,k) in categoryPlayers">{{ p.name }} - {{ p.details }}
            </option>
          </select>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-6">
          <button @click="remove" class="btn btn-danger">הסר</button>
        </div>
        <div class="col-6">
          <button @click="save" class="btn btn-success">שמור וסגור</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AvatarCropper from "vue-avatar-cropper"

export default {
  name: "CategoryEditModal",
  props: ['showModal', 'category', "userId", "imgQuality", "categoryPlayers"],
  components: {AvatarCropper},
  data() {
    return {}
  },
  methods: {
    save() {
      this.$emit('saveCategories');
    },
    remove() {
      this.$emit('removeCategory');
    },
    handleUploaded1(resp) {
      if (resp.status)
        this.category.images.main = resp.url;
    },
    handleUploaded2(resp) {
      if (resp.status)
        this.category.images.sill = resp.url;
    },
    handleUploaded3(resp) {
      if (resp.status)
        this.category.images.show = resp.url;
    },
  }
}
</script>

<style scoped lang="scss">
.popup {
  .popup-image {

    @media (max-width: 768px) {
      height: 40vw;
      width: 80vw;
    }

    @media (min-width: 769px) {
      height: 180px;
      width: 360px;
    }
  }

  .popup-image-item {
    background: white center/cover no-repeat;
    width: 100%;
    height: 100%;
    border: 1px solid lightgrey;
    border-radius: 10px;
  }

  .row {
    max-width: 360px;
    margin: 0 0 0 auto;
  }

  select, input {
    direction: rtl;
    text-align: right;
    width: 100%;
  }

  @media (max-width: 768px) {
    h3 {
      font-size: 1.5rem;
    }
  }
}

</style>
